import { useSelectedAccount } from "../../contexts/AccountContext"
import Modal from "../Modal"

type Props = {
  onClose: () => void
}

const OrgSelectorModal = ({ onClose }: Props) => {
  const { organizations, selectedOrganizationId, setSelectedOrganizationId } = useSelectedAccount()

  const handleSelect = (id: number) => {
    setSelectedOrganizationId(id)
    onClose()
  }

  return (
    <Modal title={<><i className="bi bi-building" />組織を切り替え</>} onClose={onClose}>
      <ul className="org-selector-list">
        {organizations.map(org => (
          <li key={org.id} className="org-selector-list__item">
            <div className="org-selector-list__info">
              <span className="org-selector-list__name">{org.name}</span>
              <span className="org-selector-list__meta">
                メンバー: {org.active_members_count}名{"　"}アカウント: {org.instagram_accounts_count}件
              </span>
            </div>
            {org.id === selectedOrganizationId ? (
              <span className="org-selector-list__badge">選択中</span>
            ) : (
              <button className="btn-secondary btn-secondary--sm" onClick={() => handleSelect(org.id)}>
                切り替え
              </button>
            )}
          </li>
        ))}
      </ul>
    </Modal>
  )
}

export default OrgSelectorModal
